import { Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitAction } from "../../redux/action";
import { Link } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { onlyNumber } from "../../constant/utils";
import { validatePartner } from "../../constant/validation";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  FirstName: "",
  LastName: "",
  Mobile: "",
  EmailId: "",
  CityId: "",
  Address: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha:""
};
const BecomePartner = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [values, setValues] = useState<any>({ ...initialValue });
  const cityData = useSelector((state: any) => state.dashboard.cityAll);

  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);

  const handleSubmit = (value: any) => {
    let data: any = {};
    let city = value.CityId.split(",");
    data.FirstName = value.FirstName;
    data.LastName = value.LastName;
    data.Mobile = value.Mobile;
    data.Email = value.EmailId;
    data.CityId = city[0];
    data.Address = value.Address;
    data.CityName = city[1];
    data.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    data.UtmSource = urlParams.get("utm_source");
    data.UtmMedium = urlParams.get("utm_medium");
    data.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitPartnerAction(data, history));
  };
  return (
    <>
      <SeoAdd slug={ROUTE.BECOMWEPARTNER} />
      <BreadCrumb page={t("bread_partner")} data={{ slug: "", path: "" }} />
      <section className="about-section padtp-20">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                <img src={t("images.partner.banner")} className="scale round_img" alt="" />
                <div className="headingmains text-center pb-3">
                  <h1 className="right aos-init mt-3 mt-lg-5">{t("partner_page")}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div className="row pt-lg-3">
            <div className="col-md-7">
              <div className="partnerDetais part-headfont w-100">
                <h5>{t("partner_highlights")}</h5>
                <ul>
                  <li>{t("partner_part_of_india")}</li>
                  <li>{t("partner_investment")}</li>
                  <li>{t("partner_return_investment")}</li>
                  <li>{t("partner_collection_center")}</li>
                </ul>
                <h5>{t("partner_eligibility")}</h5>
                <ul>
                  <li>{t("partner_office_space")}</li>
                  <li>{t("partner_medical_experience")}</li>
                  {/* <li>{t("partner_good_return_investment")}</li> */}
                  <li>{t("partner_motivation")}</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="w-100">
                <div className="h-services remmt-car-form">
                  <div className="infobox_wrapper">
                    <Formik
                      initialValues={initialValue}
                      enableReinitialize={true}
                      validationSchema={validatePartner}
                      onSubmit={(val: any) => {
                        handleSubmit(val);
                      }}
                      render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>
                          {/* <h4 className="mr-10">Become A Vendor</h4> */}
                          <h6 className="ln-1 mr-10">{t("partner_interest")}</h6>
                          <div className="form-group">
                            <input
                              type="text"
                              name="FirstName"
                              className="form-control"
                              placeholder={t("first_name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.FirstName}
                            />
                            {touched?.FirstName && errors?.FirstName && (
                              <span className="error_message">{t(errors?.FirstName)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="LastName"
                              className="form-control"
                              placeholder={t("last_name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.LastName}
                            />
                            {touched?.LastName && errors?.LastName && (
                              <span className="error_message">{t(errors?.LastName)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="Mobile"
                              className="form-control"
                              placeholder={t("mobile_number")}
                              onKeyPress={onlyNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Mobile}
                            />
                            {touched?.Mobile && errors?.Mobile && (
                              <span className="error_message">{t(errors?.Mobile)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="EmailId"
                              className="form-control"
                              placeholder={t("email")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.EmailId}
                            />
                            {touched?.EmailId && errors?.EmailId && (
                              <span className="error_message">{errors?.EmailId}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="CityId"
                              id="CityId"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.CityId}
                            >
                              <option value="">{t("city-with*")}</option>
                              {cityData &&
                                cityData.length > 0 &&
                                cityData?.map((item: any, i: any) => (
                                  <option className="text-uppercase" value={item?.Id + "," + item?.Name} key={i}>
                                    {t(item?.Name)}
                                  </option>
                                ))}
                            </select>
                            {touched?.CityId && errors?.CityId && (
                              <span className="error_message">{t(errors?.CityId)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={t("address")}
                              name="Address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Address}
                            />
                            {/* {touched?.Address && errors?.Address &&<span className="error_message">{errors?.Address}</span>} */}
                          </div>
                          <div className="d-flex for-check-style">
                            <input
                              type="checkbox"
                              name="Checkbox"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="checkbox_id"
                            />
                            <label className="mx-2" htmlFor="checkbox_id">
                              By clicking you accept to the{" "}
                              <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                                terms and conditions
                              </a>{" "}
                              and the{" "}
                              <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                                Privacy Policy.
                              </a>
                            </label>
                          </div>
                          <div>
                            {touched?.Checkbox && errors?.Checkbox && (
                              <span className="error_message">{errors?.Checkbox}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <Recaptcha
                              touch={touched?.GRecaptcha}
                              error={errors?.GRecaptcha}
                              onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                              onExpired={()=> setFieldValue("GRecaptcha", "")}
                            />
                          </div>

                          <button type="submit" className="book--hexagon active">
                            <span>
                              {t("submit_btn")}
                              <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                            </span>
                          </button>
                          <div className="f-10">{t("partner_terms_condition")}</div>
                        </form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BecomePartner;
